import { Power1 } from 'gsap';
import * as PIXI from 'pixi.js';
import Preset from '../Preset';
import Ring from '../../graphics/Ring';

const DEFAULT_SECTIONS = 8;
const RING_ANIMATION_PORTION = 1 / 3;

export default class Bullseye extends Preset {
  /**
   * fusedRing is rendered in place of individual rings
   * to draw multiple rings as a single continuous ring when appropriate
   *
   * @type {Ring}
   */
  fusedRing = new Ring();

  constructor(app, sections = DEFAULT_SECTIONS) {
    super({ app, isFullScreen: true });

    this.sections = sections;
    this.rings = [];
    for (let i = 0; i < sections; i++) {
      this.rings.push(new Ring());
    }
  }

  update(model) {
    super.update(model);

    const { x, y, width, height } = this.root;
    const halfDuration = model.duration / 2;
    const ringDuration = halfDuration * RING_ANIMATION_PORTION;
    const ringStagger = halfDuration - ringDuration;
    const maxRadius = Math.sqrt(width ** 2 + height ** 2) / 2;

    const center = new PIXI.Point(x + width / 2, y + height / 2);

    this.fusedRing.color = this.primaryColor;
    this.fusedRing.center = center;
    this.fusedRing.radius = maxRadius;

    this.rings.forEach((ring, index) => {
      const indexScale = index / this.sections;

      ring.color = this.primaryColor.clone();
      ring.center = center;
      ring.alpha = 0;
      ring.radius = 0;
      ring.thickness = 0;

      this.animate(ring)
        .to(
          {
            alpha: this.primaryColor.getAlpha(),
            radius: maxRadius - maxRadius * indexScale,
            thickness: maxRadius / this.sections,
            duration: ringDuration,
            ease: Power1.easeOut,
          },
          indexScale * ringStagger
        )
        .reverseOut();
    });
  }

  render() {
    super.render();
    this.fusedRing.thickness = 0;

    // Either render each ring individually, or merge into the fusedRing
    this.rings.forEach((ring) => {
      const fusedInnerRadius = Math.floor(
        this.fusedRing.radius - this.fusedRing.thickness
      );
      if (fusedInnerRadius > Math.ceil(ring.radius)) {
        ring.draw(this.graphics);
      } else {
        this.fusedRing.thickness += ring.thickness;
      }
    });

    if (this.fusedRing.thickness > 0) {
      // Drawing fusedRing in place of multiple individual rings
      // avoids tiny (but visible) gaps and overlaps between rings
      this.fusedRing.draw(this.graphics);
    }
  }
}
